module.exports = __webpack_public_path__ + "static/media/loginScreenBackground.77fe89a6.png";